import FeatureGrid from "@/components/base/FeatureGrid";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { patientSafetyCards } from "@/mocks/patientInfo";

export default function PatientSafety() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Güvenlik & mahremiyet"
            title="Düşük doz, tam gizlilik"
            description="Modern dijital cihazlarımız ve uyguladığımız protokoller, güvenliğinizi önceliklendirir."
          />
        </Reveal>

        <div className="mt-14">
          <FeatureGrid items={patientSafetyCards} columns={3} />
        </div>
      </div>
    </section>
  );
}